export default __webpack_public_path__ + "static/media/mobile-chat.a4ebfaf3.svg";